module.exports = __webpack_public_path__ + "img/1A2461_3D70DB_2C3C8F_2C6CAC-256px.e1e9e902.png";